exports = module.exports = require("../../../math-wordproblems/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fraction-component[data-v-2d51e9c6]{display:inline-block;vertical-align:middle;text-align:center;margin-right:0 .25rem}.fraction-component .numerator-fraction[data-v-2d51e9c6]{text-align:center!important;margin-bottom:-.25rem}.fraction-component .separator-fraction[data-v-2d51e9c6]{border-bottom:1px solid grey}.fraction-component .denominator-fraction[data-v-2d51e9c6]{margin-top:-.25rem;text-align:center!important}.fraction-component input[data-v-2d51e9c6]{text-align:center}", ""]);

// exports
